import _ from 'lodash';

export default (obj, path, defaultValue) => _.defaultTo(_.get(obj, path), defaultValue);
